export const formatTime = (timeInSeconds: number) => {
  // Hours, minutes and seconds
  const hrs = ~~(timeInSeconds / 3600)
  const mins = ~~((timeInSeconds % 3600) / 60)
  const secs = ~~timeInSeconds % 60

  let ret = ''
  if (hrs > 0) {
    ret += '' + hrs + ':' + (mins < 10 ? '0' : '')
  }
  ret += '' + mins + ':' + (secs < 10 ? '0' : '')
  ret += '' + secs
  return ret
}

export const getDayNumber = (str: string) =>
  parseInt(str.toString()?.replace(/[^0-9]/g, ''))
